import type { TutorialRecover } from './types';

const DEFAULT_TARGET_MISSING_HINT =
  '안내 화면을 찾지 못했어요. 이전 화면으로 돌아가 주세요. 화면을 찾으면 하이라이트가 다시 나타나요.';

/**
 * recover의 pageLabel·openLabel로 "어느 화면을 열지" 구체 안내를 만든다.
 * `explicitHint`가 있으면 그대로 쓴다.
 */
export function buildTutorialTargetMissingHint(
  recover?: TutorialRecover | null,
  explicitHint?: string | null
): string {
  const explicit = explicitHint?.trim();
  if (explicit) return explicit;

  const page = recover?.pageLabel?.trim();
  const open = recover?.openLabel?.trim();
  const access = (recover?.accessLabel ?? '사이드바').trim() || '사이드바';

  if (page && open) {
    return `안내 화면을 찾지 못했어요. ${access}에서 「${page}」을 연 뒤, 「${open}」을 눌러 주세요. 화면을 찾으면 하이라이트가 다시 나타나요.`;
  }
  if (page) {
    return `안내 화면을 찾지 못했어요. ${access}에서 「${page}」 페이지를 열어 주세요. 화면을 찾으면 하이라이트가 다시 나타나요.`;
  }
  if (open) {
    return `안내 화면을 찾지 못했어요. 「${open}」을 눌러 화면을 열어 주세요. 화면을 찾으면 하이라이트가 다시 나타나요.`;
  }
  return DEFAULT_TARGET_MISSING_HINT;
}

export { DEFAULT_TARGET_MISSING_HINT };
